// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.CreateRenterPaymentMethodWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateRenterPaymentMethodWebApiRequestDto, CreateRenterPaymentMethodWebApiResponseDto } from '../..';

export const CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod_Path =
  '/api/web/v1/createRenterPaymentMethod';

/**
 * create renter payment method
 */
export const CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod = (
  postData: CreateRenterPaymentMethodWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    CreateRenterPaymentMethodWebApiRequestDto,
    CreateRenterPaymentMethodWebApiResponseDto
  >(
    {
      endpoint: CreateRenterPaymentMethodWebApiHandler_createRenterPaymentMethod_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
